// src/hooks/useTenantConfig.js
import { useEffect, useState } from "react";
import AdminService from "./AdminService";
const initTenantDataFun = (tenantId, sf = []) => {
  return ([
    {
      tenantId: tenantId || "",
      config: {
        sf: sf,
      },
    },
  ])
};

/**
 * Fetches the tenant config and returns the server response as-is.
 * No normalization or restructuring is done here.
 */
export function useTenantConfig({ tenantId, enabled = true } = {}) {
  const [data, setData] = useState(null); // raw response from API (array or object)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTenantConfig = async () => {
    if (!tenantId || !enabled) return;
    setLoading(true);
    setError(null);

    try {
      const res = await AdminService.getSFConnection();
      console.log("res ", res);
      setData(initTenantDataFun(tenantId, res)); // 🚫 no normalization — keep raw
    } catch (err) {
      console.log("err", err);
      // setError(err);
      setData(initTenantDataFun(tenantId))
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTenantConfig();
  }, [enabled]);

  return { data, loading, error, refetch: fetchTenantConfig, setData };
}
